import { index as getList } from "~/api/counterparty";
import * as types from "../mutation-types";

/**
 * Initial state
 */
export const state = {
  list: null,
  isLoad: false,
  isInitialLoadPending: true
};

/**
 * Mutations
 */
export const mutations = {
  [types.SET_COUNTERPARTIES](state, data) {
    state.list = data;
    state.isInitialLoadPending = false;

  },
  [types.SET_IS_LOADING_SET_COUNTERPARTIES](state, status) {
    state.isLoad = status;
  }
};

/**
 * Actions
 */
export const actions = {
  async fetchCounterparties({ commit }) {
    commit(types.SET_IS_LOADING_SET_COUNTERPARTIES, true);

    try {
      const response = await getList();
      let { data } = response;
      commit(types.SET_COUNTERPARTIES, data.data);
    } catch (e) {
      console.error('Error fetching counterparties:', e);
    } finally {
      commit(types.SET_IS_LOADING_SET_COUNTERPARTIES, false);
    }
  }
};

/**
 * Getters
 */
export const getters = {
  list: (state) => state.list,
  isInitialLoadPending: (state) => state.isInitialLoadPending,
  isLoad: (state) => state.isLoad
};
